var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.89114V9C13 9.56832 12.786 10.1134 12.4051 10.5152C12.0241 10.9171 11.5075 11.1429 10.9688 11.1429H2.03125C1.49253 11.1429 0.975873 10.9171 0.594939 10.5152C0.214006 10.1134 0 9.56832 0 9V2.89114L6.29363 6.798C6.35615 6.8369 6.42741 6.85742 6.5 6.85742C6.57259 6.85742 6.64385 6.8369 6.70638 6.798L13 2.89114ZM10.9688 2.65309e-08C11.4686 -8.28994e-05 11.9508 0.194234 12.3234 0.545777C12.6959 0.89732 12.9324 1.38141 12.9878 1.90543L6.5 5.93143L0.0121876 1.90543C0.0675661 1.38141 0.304138 0.89732 0.676646 0.545777C1.04915 0.194234 1.53144 -8.28994e-05 2.03125 2.65309e-08H10.9688Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7985cd37fb39dd34e0a552439c2fcb9c.svg";
export { ForwardRef as ReactComponent };